'use client';

import { AlertCircle } from 'lucide-react';

interface FieldErrorProps {
  message?: string;
  id?: string;
}

export default function FieldError({ message, id }: FieldErrorProps) {
  if (!message) return null;

  return (
    <p
      id={id}
      role="alert"
      className="flex items-start gap-1.5 text-xs text-destructive mt-1.5 font-500 animate-fade-in"
    >
      <AlertCircle className="w-3.5 h-3.5 flex-shrink-0 mt-0.5" aria-hidden="true" />
      <span>{message}</span>
    </p>
  );
}